<template >
  <div v-loading="loading">

    <el-dialog ref="ssDialog" :show-close="false" :close-on-press-escape="false" :title="$t('SELECT_PARTICIPANT')"
      :visible.sync="showRelationDialog" :close-on-click-modal="false" width="90%" center custom-class="round-dialog">

      <ParticipantCHeckbox :participants="availablePeople" ref="participantCheckBoxs">
      </ParticipantCHeckbox>

      <div>
        <el-button class="gradient-button1" type="primary" @click="setParticipants">{{ $t("next") }}</el-button>
      </div>

    </el-dialog>

    <div v-show="!showRelationDialog && !showNextStepDialog">
      <el-card>
        <el-row v-show="!isFirst" class="description">
          <h3>{{ $t('INPUT_ADDRESS') }}</h3>
        </el-row>

        <el-row v-show="isFirst" class="description">
          <h3>{{ $t('START_BTN_REGISTER') }}</h3>
        </el-row>

        <el-form class="main-form" @submit.native.prevent="submitAddress">
          <br />
          <el-form-item>
            <el-radio-group v-model="regionType">
              <div class="region-select-box">
                <el-radio label="macao">{{ $t("macau_address") }} </el-radio>
              </div>
              <div class="region-select-box">
                <el-radio label="china">{{ $t("china_address") }} </el-radio>
              </div>
              <div class="region-select-box">
                <el-radio label="oversea">{{ $t("oversea_address") }}</el-radio>
              </div>
            </el-radio-group>
          </el-form-item>

          <oversea-area v-if="regionType == 'oversea'" ref="overseaaddress"
            :showIncompleteInputParent="showIncompleteInput" :showWarningParent="showWarning"
            :showInvalidFieldParent="showInvalidField"></oversea-area>
          <china-area v-if="regionType == 'china'" ref="chinaaddress" :showIncompleteInputParent="showIncompleteInput"
            :showWarningParent="showWarning" :showInvalidFieldParent="showInvalidField"></china-area>
          <macao-area v-if="regionType == 'macao'" ref="macaoaddress" :showIncompleteInputParent="showIncompleteInput"
            :showWarningParent="showWarning" :showInvalidFieldParent="showInvalidField"></macao-area>


          <br />

          <el-form-item>
            <el-button class="main-button gradient-button1" type="primary" @click="displayNextStepDialog" block>
              {{ $t("next") }}
            </el-button>
          </el-form-item>
          <el-form-item>
            <el-button class="main-button gradient-button2" @click="backToRelation" type="danger" block>
              {{ $t("back") }}
            </el-button>
          </el-form-item>
        </el-form>


      </el-card>
    </div>
    <el-dialog class="next-step-dialog" :show-close="false" :title="$t('PLEASE_CONFIRM_ADDRESS')"
      :visible.sync="showNextStepDialog" width="90%" center custom-class="round-dialog">
      <p>{{ this.fulladdress }}</p>
      <div slot="footer" class="dialog-footer">
        <el-button class="gradient-button1" type="primary" @click="handleUpdateContact">{{ $t("next") }}</el-button>
        <br />
        <br />
        <el-button class="gradient-button2" type="danger" @click="showNextStepDialog = false">{{ $t("back") }}
        </el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import ChinaArea from './ChinaArea.vue'
import { getLocale } from "@/i18n.js";
import base64 from 'base-64';
import utf8 from 'utf8';

import {
  updateContactAndSync,
  getCurrentMid,
  validateAddress,
  getAddressData,
} from "../api/contact.js";
import OverseaArea from './OverseaArea.vue';
import MacaoArea from "./MacaoArea.vue";

import { qualifyMid } from "@/api/contact.js";
import ParticipantCHeckbox from "./ParticipantCHeckbox.vue";


export default {
  components: { ChinaArea, OverseaArea, MacaoArea, ParticipantCHeckbox },
  data() {
    return {
      loading: true,
      showRelationDialog: true,
      showNextStepDialog: false,
      regionType: 'macao',
      availablePeople: [],
      participants: [],
      names: {},
      address: {},
      idList: [],
      isFirst: false,
    };
  },
  created() { },
  async mounted() {
    this.isFirst = this.$route.query.first;

    const isQualify = await this.checkQualification();
    if (isQualify) {
      await this.getIdentity();
      await this.loadLatestAddressData();
    }
  },

  computed: {
    fulladdress() {
      //important to call this.loading!!!!!
      this.loading;
      //console.log('loading : ', this.loading)
      let component = this.getAddressComponet();

      if (!component) { return '' }
      return component.getFullAddress();
    }
  },

  methods: {

    showRequestFail() {
      this.$message.error(this.$t("request_fail"));
    },

    async loadLatestAddressData() {
      this.loading = true;
      try {
        const { data } = await getAddressData();
        if (data && data.status == "ok") {


          this.$nextTick(() => {
            this.$refs.macaoaddress.loadAddressData(data);
          });
        }
      } finally {
        this.loading = false;
      }
    },

    async checkQualification() {
      try {
        this.loading = true;
        const { data } = await qualifyMid();
        if (data && data.status == "ok") {
          //doNothing
          this.loading = false;
          return true;
        } else {
          this.$router.push("/start");
          return false;
        }
      } catch (e) {
        console.log(e)
        this.$message.error(this.$t("request_fail"));
        return false;

      }
    },

    getMidName(id) {
      const lang = getLocale();
      const name = lang == "zh" ? this.names[id]['cFullname'] : this.names[id]['pFullname'];
      return name;
    },


    async getIdentity() {
      let isSucessFlag = false;
      this.loading = true;
      try {
        const { data : result } = await getCurrentMid();
        if (result && result.status == "ok") {

          const raw = result.raw;
          let objStr = base64.decode(raw);
          objStr = utf8.decode(objStr)
          const data = JSON.parse(objStr);

      
          console.log('getIdentity:', data)

          this.idLIst = data.idList;
          this.names = data.names;
          this.address = data.address;
          isSucessFlag = true;

          this.availablePeople = this.idLIst.map(id => ({
            mid: id,
            name: this.getMidName(id),
            address: this.address[id]
          }));

        }
      } finally {
        this.loading = false;
        if (!isSucessFlag) {
          this.showRequestFail();
          this.handleRequestFail();
        }
      }
    },

    setParticipants() {
      let checkboxs = this.$refs.participantCheckBoxs;
      this.participants = checkboxs.checkedList;
      console.log('setParticipants:', this.participants);
      this.showRelationDialog = false;
    },

    async handleUpdateContact() {
      this.showNextStepDialog = false;
      this.loading = true;
      const lang = getLocale();

      let contact = this.getSubmitObject();
      const idList = this.participants;

      console.log('handleUpdateContact:')
      console.log(contact);
      console.log(idList);

      try {
        const { data } = await updateContactAndSync(contact, idList, lang);

        console.log(data);
        if (data && data.status == "ok") {
          this.$router.push("/sync-services");
        } else if (data && data.status == "login_require") {
          this.$router.push("/login");
        } else {
          this.showInputInvalid();
        }
      } catch (e) {
        this.showInputInvalid();
      } finally {
        this.loading = false;
      }
    },


    getAddressComponet() {
      if (this.regionType == 'macao') {
        return this.$refs.macaoaddress
      } else if (this.regionType == 'oversea') {
        return this.$refs.overseaaddress
      } else if (this.regionType == 'china') {
        return this.$refs.chinaaddress
      } else {
        return null
      }
    },

    validForm() {
      return this.getAddressComponet().validForm();
    },

    getSubmitObject() {
      return this.getAddressComponet().getSubmitObject();
    },

    async displayNextStepDialog() {
      if (!this.validForm()) {
        return;
      }
      try {

        this.loading = true;

        const { data } = await validateAddress(this.fulladdress);
        if (data && data.status == "ok") {
          this.showNextStepDialog = true;
        } else {
          this.showInvalidField(this.$t("ADDRESS"));
        }
      } catch (e) {
        this.showInvalidField(this.$t("ADDRESS"));
      } finally {
        this.loading = false;
      }
    },


    showInputInvalid() {
      this.$message.error(this.$t("input_invalid"));
    },

    showIncompleteInput(message = "") {
      if (message !== "") {
        this.showWarning(this.$t("input_incomplete") + ":" + message);
      } else {
        this.showWarning(this.$t("input_incomplete"));
      }
    },

    showInvalidField(field, message = "") {
      if (message !== "") {
        this.showWarning(
          "(" + field + ")" + this.$t("input_invalid") + ":" + message
        );
      } else {
        this.showWarning("(" + field + ")" + this.$t("input_invalid"));
      }
    },
    showWarning(message, showClose = true) {
      this.$message({ type: "warning", showClose, duration: 10000, message });

    },

    handleRequestFail() {
      this.$router.push("/login");
    },

    backToLogin() {
      this.$router.push("/login");
    },

    backToRelation() {
      this.showRelationDialog = true;
    },


  },
};
</script>

<style lang="scss">
.region-select-box {
  margin-bottom: 20px;
}

.input-select {
  float: left;
  width: 60%;
}

.type-selector {
  width: 40%;
  background-color: #e7f3f7;
  color: #13a07b;
  float: left;
}

.other-tips {
  color: rgb(146, 193, 247);
  font-size: 12px;
}

.el-checkbox__label {
  display: inline;
}

.el-checkbox,
.el-checkbox__input {
  white-space: normal;
}

.el-dialog {
  max-width: 400px;
}

.next-step-dialog .el-dialog {
  max-width: 700px;
}

label.el-form-item__label {
  font-size: 14px;
}


.main-form .el-radio__label {
  padding-right: 10px;
}
</style>
<style scoped>
.remark {
  font-size: 11px;
  word-break: normal;
  word-wrap: break-word;
}

.input-label {
  font-size: 12px;
  margin-bottom: 10px;
}



.main-form {
  min-width: 320px;
}
</style>
